import axios from 'axios';
import {
  FileUploadSetting,
  UploadedFileInfoDetailRequestPiclib,
  UploadedFileInfoDetailResponse,
  FormAuthenticatedData,
} from 'backend';
import { getAuthorizationHeaderProperty, getRequestHeaders } from '../shared';

const REQUEST_TYPE: UploadedFileInfoDetailRequestPiclib['type'] = 'piclib';

type GetUploadedFileInfoFromPiclibPayload = Pick<
  UploadedFileInfoDetailRequestPiclib,
  'propertyId' | 'fileSrn'
> & {
  thumbnailApiEndpoint: NonNullable<FileUploadSetting['thumbnailApiEndpoint']>;
  authentication: FormAuthenticatedData;
};

export const getUploadedFileInfoFromPiclib = async ({
  fileSrn,
  propertyId,
  thumbnailApiEndpoint,
  authentication,
}: GetUploadedFileInfoFromPiclibPayload): Promise<UploadedFileInfoDetailResponse> => {
  const payload: UploadedFileInfoDetailRequestPiclib = {
    type: REQUEST_TYPE,
    fileSrn,
    propertyId,
  };
  const headersPayload = {
    'X-From': location.origin,
    Authorization: getAuthorizationHeaderProperty(authentication.token),
  };
  const result = await axios.post(thumbnailApiEndpoint, payload, {
    headers: getRequestHeaders(headersPayload),
  });
  return result.data;
};
